import reportsInfo from '@/mockData/attendance.json'
import AttendanceService from '@/services/api/attendance.services'

// function checkLength(val) {
//     return String(val).length === 1 ? '0' + val : val
// }

const state = {
    reports: reportsInfo,
    currentUserInfo: {},
    currentUserInfoAll: [],
    workingUsers: [],
    userReports: [],
    wastedTime: [],
    taskProgress: [],
    taskReports: [],
    taskDetails: []

}

const mutations = {
    SET_CURRENT_DATA(state, payload) {
        state.currentUserInfo = payload

    },
    SET_WASTED_TIME(state, payload) {
        state.wastedTime = payload

    },

    SET_TASK_PROGRESS(state, payload) {
        state.taskProgress = payload

    },

    SET_TASK_REPORTS(state, payload) {
        state.taskReports = payload

    },
    SET_EXCEL() {


    },


    SET_TASK_DETAILS(state, payload) {
        state.taskDetails = []
        state.taskDetails = payload

    },
  SET_CURRENT_DATA_ALL(state, payload) {
    state.currentUserInfoAll = payload

  },
    SET_WORKING_USERS(state, payload) {
        state.workingUsers = payload
    },
    SET_USER_REPORTS(state, payload) {
        state.userReports = payload
    }
}

const actions = {
    beginWorkingDay({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.startWorkingDay()
                .then(() => {
                    AttendanceService.getCurrentInfo()
                        .then((response) => {
                            commit('SET_CURRENT_DATA', response.data.data)

                            AttendanceService.getWorkingUsers()
                                .then((res) => {
                                    commit('SET_WORKING_USERS', res.data.data)
                                    return resolve(res)
                                })
                                .catch((error) => reject(error))

                            return resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },
    setPause({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.startPause()
                .then(() => {
                    AttendanceService.getCurrentInfo()
                        .then((response) => {
                            commit('SET_CURRENT_DATA', response.data.data)

                            AttendanceService.getWorkingUsers()
                                .then((res) => {
                                    commit('SET_WORKING_USERS', res.data.data)
                                    return resolve(res)
                                })
                                .catch((error) => reject(error))

                            return resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },
    endPause({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.endPause()
                .then(() => {
                    AttendanceService.getCurrentInfo()
                        .then((response) => {
                            commit('SET_CURRENT_DATA', response.data.data)

                            AttendanceService.getWorkingUsers()
                                .then((res) => {
                                    commit('SET_WORKING_USERS', res.data.data)
                                    return resolve(res)
                                })
                                .catch((error) => reject(error))

                            return resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },
    endWorkingDay({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.endWorkingDay({ reports: [] })
                .then(() => {
                    AttendanceService.getCurrentInfo()
                        .then((response) => {
                            commit('SET_CURRENT_DATA', response.data.data)

                            AttendanceService.getWorkingUsers()
                                .then((res) => {
                                    commit('SET_WORKING_USERS', res.data.data)
                                    return resolve(res)
                                })
                                .catch((error) => reject(error))
                            return resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },
    setCurrentInfo({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.getCurrentInfo()
                .then((response) => {
                    commit('SET_CURRENT_DATA', response.data.data)

                    AttendanceService.getWorkingUsers()
                        .then((res) => {
                            commit('SET_WORKING_USERS', res.data.data)
                            return resolve(res)
                        })
                        .catch((error) => reject(error))

                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
  setCurrentInfoAll({ commit }) {
    return new Promise((resolve, reject) => {
      AttendanceService.getCurrentInfoAll()
        .then((response) => {
          commit('SET_CURRENT_DATA_ALL', response.data.data)

          // AttendanceService.getWorkingUsers()
          //   .then((res) => {
          //     commit('SET_WORKING_USERS', res.data.data)
          //     return resolve(res)
          //   })
          //   .catch((error) => reject(error))

          return resolve(response)
        })
        .catch((error) => reject(error))
    })
  },
    setReports({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.setReports(payload)
                .then(() => {
                    AttendanceService.getCurrentInfo()
                        .then((response) => {
                            commit('SET_CURRENT_DATA', response.data.data)

                            AttendanceService.getWorkingUsers()
                                .then((res) => {
                                    commit('SET_WORKING_USERS', res.data.data)
                                    return resolve(res)
                                })
                                .catch((error) => reject(error))

                            return resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .then((response) => resolve(response))
                .catch((error) => reject(error))
        })
    },
    editReports({ commit }, payload) {
      return new Promise((resolve, reject) => {
          AttendanceService.editReports(payload)
              .then(() => {
                  AttendanceService.getCurrentInfo()
                      .then((response) => {
                          commit('SET_CURRENT_DATA', response.data.data)

                          AttendanceService.getWorkingUsers()
                              .then((res) => {
                                  commit('SET_WORKING_USERS', res.data.data)
                                  return resolve(res)
                              })
                              .catch((error) => reject(error))

                          return resolve(response)
                      })
                      .catch((error) => reject(error))
              })
              .then((response) => resolve(response))
              .catch((error) => reject(error))
      })
  },
    getUserReports({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.getUserReports(payload)
                .then((response) => {

                    commit('SET_USER_REPORTS', response.data.data)

                    return resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },
    getGeneralReports({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.getGeneralReports(payload)
                .then((response) => {

                    commit('SET_USER_REPORTS', response.data.data)

                    return resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },
    getWastedTime({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.getWastedTime(payload)
                .then((response) => {

                    commit('SET_WASTED_TIME', response.data.data)

                    return resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },
    getTaskProgress({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.getTaskProgress(payload)
                .then((response) => {

                    commit('SET_TASK_PROGRESS', response.data.data)

                    return resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },

    getTaskReports({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.getTaskReports(payload)
                .then((response) => {

                    commit('SET_TASK_REPORTS', response.data.data)

                    return resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },

    async getExcel({ commit }, payload) {
        try {
            const response = await AttendanceService.getExcel(payload,{
                responseType: 'blob'
            });


            const fileData = response.data;

            const fileName = 'report.xlsx';

            const url = window.URL.createObjectURL(new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));


            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);


            document.body.appendChild(link);
            link.click();


            document.body.removeChild(link);


            commit('SET_EXCEL', response.data);

            return fileName;
        } catch (error) {
            console.error('Ошибка при загрузке файла', error);
            throw error;
        }
    },


    getTaskDetails({ commit }, payload) {
        return new Promise((resolve, reject) => {
            AttendanceService.getTaskDetails(payload)
                .then((response) => {

                    commit('SET_TASK_DETAILS', response.data.data)

                    return resolve(response.data.data)
                })
                .catch((error) => reject(error))
        })
    },
    resumeWorkingDay({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.resumeWorkingDay()
                .then(() => {
                    AttendanceService.getCurrentInfo()
                        .then((response) => {
                            commit('SET_CURRENT_DATA', response.data.data)

                            AttendanceService.getWorkingUsers()
                                .then((res) => {
                                    commit('SET_WORKING_USERS', res.data.data)
                                    return resolve(res)
                                })
                                .catch((error) => reject(error))

                            return resolve(response)
                        })
                        .catch((error) => reject(error))
                })
                .catch((error) => reject(error))
        })
    },
    getWorkingUsers({ commit }) {
        return new Promise((resolve, reject) => {
            AttendanceService.getWorkingUsers()
                .then((response) => {
                    commit('SET_WORKING_USERS', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getBeginDayStatus: (state) =>
        state.currentUserInfo ? Boolean(state.currentUserInfo.start) : false,
    getEndDayStatus: (state) =>
        state.currentUserInfo ? Boolean(state.currentUserInfo.end) : false,
    getPauseStatus: (state) =>
        state.currentUserInfo
            ? state.currentUserInfo.pauses.length > 0 &&
            state.currentUserInfo.pauses.some(
                (pause) => Boolean(pause.end) === false,
            )
            : [],
    getDayBeginning: (state) =>
        state.currentUserInfo ? state.currentUserInfo.start : '',
    getDayEnding: (state) => (user) =>
        state.reports[user]?.find(
            (item) =>
                item &&
                new Date(item.date).getDate() +
                '/' +
                new Date(item.date).getMonth() +
                '/' +
                new Date(item.date).getFullYear() ===
                new Date().getDate() +
                '/' +
                new Date().getMonth() +
                '/' +
                new Date().getFullYear(),
        )?.dayEnding,
    getWorkingUsers: (state) => state.workingUsers,
    getCurrentDayData: (state) => state.currentUserInfo,
    getCurrentDayDataAll: (state) => state.currentUserInfoAll,
    getIsLoadedUser: (state) => state.currentUserInfo.start,
    getWastedTime: (state) => state.wastedTime,
    getTaskProgress: (state) => state.taskProgress,
    getTaskReports: (state) => state.taskReports,
    getTaskDetails: (state) => state.taskDetails
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
